import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

export interface PropsDiv {
  type: string;
}

export const HeaderCover = styled(NavLink)`
  position: relative;
`;

export const TypePost = styled.div<PropsDiv>`
  ${props => {
    switch (props.type) {
      case 'Rascunho':
        return `background-color: ${props.theme.colors.blue};`;
      case 'Agendada':
        return `background-color: ${props.theme.colors.warning};`;
      case 'Publicada':
        return `background-color: ${props.theme.colors.success};`;
      default:
        return ` background-color: ${props.theme.colors.success};`;
    }
  }}

  padding: ${props => props.theme.spacing.xxs} ${props => props.theme.spacing.xs};
  color: ${props => props.theme.colors.white};
  border: none;
  border-radius: ${props => props.theme.radii.sm};
  position: absolute;
  top: 16px;
  right: 16px;

  font-family: ${props => props.theme.typography.fontFamily};
  font-style: normal;
  font-weight: ${props => props.theme.typography.weights.medium};
  font-size: ${props => props.theme.typography.sizes.xs};
  line-height: ${props => props.theme.typography.lineHeights.xs};
`;

export const LinkStyled = styled.h3`
  text-decoration: none;
  color: ${props => props.theme.colors.textSecondary};
  font-size: ${props => props.theme.typography.sizes.lg};
  line-height: ${props => props.theme.typography.lineHeights.lg};
  margin-bottom: ${props => props.theme.spacing.md};
  transition: 0.3s;
`;

export const Container = styled(NavLink)`
  text-decoration: none;
  padding-left: ${props => props.theme.spacing.lg};
  padding-top: ${props => props.theme.spacing.lg};
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 360px;
  -moz-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  object-fit: cover;
`;

export const Card = styled.div`
  background: ${props => props.theme.colors.surface};
  border: 1px solid ${props => props.theme.colors.border};
  box-shadow: ${props => props.theme.shadows.sm};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 413px;
  width: 100%;
  min-height: 413px;
  border-radius: ${props => props.theme.radii.lg};

  cursor: pointer !important;
  text-decoration: none !important;
  overflow: hidden !important;

  :hover {
    box-shadow: ${props => props.theme.shadows.md};
  }

  :hover ${LinkStyled} {
    color: ${props => props.theme.colors.textPrimary};
    transition: 0.3s;
  }

  :hover ${Image} {
    -moz-transform: scale(1.1);
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
`;

export const ContainerSwitch = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: ${props => props.theme.spacing.lg};
`;

export const ImageIcon = styled.img`
  width: 20px;
  height: auto;
  margin-right: 0;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Tag = styled.p`
  color: ${props => props.theme.colors.textSecondary};
  background-color: ${props => props.theme.colors.grayLight};
  padding: ${props => props.theme.spacing.xxs} ${props =>
    props.theme.spacing.sm};
  border-radius: ${props => props.theme.radii.pill};
  margin: 0 0 ${props => props.theme.spacing.xs} 0;
  width: max-content;
`;

export const Content = styled.div`
  padding: ${props => props.theme.spacing.lg} 0 !important;
  display: grid;
  gap: ${props => props.theme.spacing.sm};
`;
